import React from 'react';
import QRCode from "qrcode.react";
import { render, screen, cleanup, fireEvent, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import ModalInterviewLink from './modalInterviewLink';
import axios from 'axios';

jest.mock('axios');

afterEach(cleanup);

describe('ModalInterviewLink', () => {
  describe('display interview link modal', () => {
    test('renders expected content', () => {
      const id = 1;
      const interviewKey = "a1b2c3d4e5f6g7";
      const patientName = "テスト太郎";
      const display_flg = 1; // 表示
      // const 

      render(<ModalInterviewLink id={id}
                                 interviewKey={interviewKey}
                                 patientName={patientName}
                                 display_flg={display_flg} />);

    //   screen.debug();

      expect(screen.getByText(/テスト太郎/)).toBeInTheDocument();
      expect(screen.getByDisplayValue(/a1b2c3d4e5f6g7/)).toBeInTheDocument();
      expect(screen.getByText("コピー")).toBeInTheDocument();
      expect(screen.getByText("LINE")).toBeInTheDocument();
      expect(screen.getByText("QRコードを読み取ってください")).toBeInTheDocument();
      expect(screen.getByText("スタート")).toBeInTheDocument();
      expect(screen.getByText("非表示")).toBeInTheDocument();
      expect(screen.getByText("削除")).toBeInTheDocument();
    });
  });

  describe('hide selected d_interview_detail', () => {
    test('renders expected content', async() => {
      const id = 1;
      const interviewKey = "a1b2c3d4e5f6g7";
      const patientName = "テスト太郎";
      const display_flg = 1; // 現在表示中
      const defaultIndexProps = [{id: 1, name: "テスト太郎", status: 0, kanzyano: null, display_flg: 1}];

      const promise = Promise.resolve({
        data: {
          status: "ok"
        }
      });

      (axios.patch as any).mockResolvedValue(promise);

      const {container} = render(<ModalInterviewLink id={id}
                                                     interviewKey={interviewKey}
                                                     patientName={patientName}
                                                     display_flg={display_flg}
                                                     defaultIndexProps={defaultIndexProps} />);

      await act(() => promise);

      const hideButton = screen.getByText('非表示');
      fireEvent.click(hideButton);
      // クラス名にinがないことでモーダルが消えていることを確認
      expect(await container.querySelector('#modalInterviewLink')).not.toHaveClass('in');

      // await screen.debug();
    });
  });

  describe('redisplay selected d_interview_detail', () => {
    test('renders expected content', async() => {
      const id = 1;
      const interviewKey = "a1b2c3d4e5f6g7";
      const patientName = "テスト太郎";
      const display_flg = 0; // 現在非表示
      const defaultIndexProps = [{id: 1, name: "テスト太郎", status: 0, kanzyano: null, display_flg: 0}]

      const promise = Promise.resolve({
        data: {
          status: "ok"
        }
      });

      (axios.patch as any).mockResolvedValue(promise);

      const {container} = render(<ModalInterviewLink id={id}
                                                     interviewKey={interviewKey}
                                                     patientName={patientName}
                                                     display_flg={display_flg}
                                                     defaultIndexProps={defaultIndexProps} />);

      await act(() => promise);
      
      const redisplayButton = screen.getByText('再表示');
      fireEvent.click(redisplayButton);
      // クラス名にinがないことでモーダルが消えていることを確認
      expect(await container.querySelector('#modalInterviewLink')).not.toHaveClass('in');

      // await screen.debug();
    });
  });

  describe('delete selected d_interview_detail', () => {
    test('renders expected content', async() => {
      const id = 1;
      const interviewKey = "a1b2c3d4e5f6g7";
      const patientName = "テスト太郎";
      const display_flg = 1; // 現在表示中
      const defaultIndexProps = [{id: 1, name: "テスト太郎", status: 0, kanzyano: null, display_flg: 0}]

      const promise = Promise.resolve({
        data: {
          status: "ok"
        }
      });

      (axios.patch as any).mockResolvedValue(promise);

      const {container} = render(<ModalInterviewLink id={id}
                                                     interviewKey={interviewKey}
                                                     patientName={patientName}
                                                     display_flg={display_flg}
                                                     defaultIndexProps={defaultIndexProps} />);

      await act(() => promise);
      
      const deleteButton = screen.getByText('削除');
      fireEvent.click(deleteButton);
      // クラス名にinがないことでモーダルが消えていることを確認
      expect(await container.querySelector('#modalInterviewLink')).not.toHaveClass('in');

      // await screen.debug();
    });
  });
});